"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Car.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Car = function Car(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 199.33 136.71"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Car Icon"), _react2.default.createElement("path", {
    className: "car",
    d: "M184.69 47.3h-34.52C144.83 35.47 128.79-.03 120.44-.03H45.57c-15.16 0-21 33.09-22.84 47.33h-8.08A14.67 14.67 0 0 0 0 61.97v37.88a14.67 14.67 0 0 0 14.65 14.65h10.24a27.16 27.16 0 0 0 53.41 0h45.44a27.16 27.16 0 0 0 53.41 0h7.53a14.67 14.67 0 0 0 14.65-14.65V61.97a14.66 14.66 0 0 0-14.64-14.67zm-41.78 0H92.14V6.61h27.88c3.75 2.36 14.4 22.25 22.89 40.69zM45.57 6.61h40v40.7H29.4c2.46-18.12 8.6-40.7 16.17-40.7zm6 123.5a20.56 20.56 0 1 1 20.56-20.56 20.58 20.58 0 0 1-20.56 20.55zm98.86 0a20.56 20.56 0 1 1 20.56-20.56 20.58 20.58 0 0 1-20.54 20.55zm42.27-30.27a8 8 0 0 1-8 8h-7.13a27.16 27.16 0 0 0-54.22 0H78.71a27.16 27.16 0 0 0-54.22 0h-9.84a8 8 0 0 1-8-8V61.97a8 8 0 0 1 8-8h170a8 8 0 0 1 8 8v37.88z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Car;